<template>
  <div>
    <v-container
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      class="pa-0 ma-0"
      fluid
      width="100%"
    >
      <div>
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Impresion de descuentos indebidos.'"
          :show-absolute="false"
          :titulo="'Descuentos Indebidos'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </div>

      <v-row>
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            :style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
            class="overflow-y-auto"
            style="min-height: fit-content"
          >
            <!--- Formulario --->
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">Reporte descuentos indebidos</span>
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="datos.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Sucursal --->
                        <v-autocomplete
                          v-model="datos.sucursal"
                          :items="sucursalList"
                          clearable
                          dense
                          item-text="descripcion"
                          label="Sucursal"
                          outlined
                          return-object
                          @focus.once="findAllSucursales"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="datos.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!--- Vendedor  --->
                        <v-autocomplete
                          v-model="datos.vendedor"
                          :items="vendedorList"
                          :search-input.sync="searchVendedor"
                          clearable
                          dense
                          item-text="nombre"
                          label="Vendedor"
                          outlined
                          return-object
                          @focus.once="findVendedor"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros ref="ModRepFilt" :Datos="datos" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
            <!-- fn Formulario-Historial de consumo del cliente-->
          </v-app>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "@/event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"

  import { fechaNueva, FormatoFecha } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Historial de consumo del cliente",
        descripcion: "Imprime el historial de consumo del cliente.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("ReporteCumpleañosClientesNew", this.new);
      // EventBus.$on("ReporteCumpleañosClientesSave", this.save);
      // EventBus.$on("ReporteCumpleañosClientesRemove", this.remove);
      // EventBus.$on("ReporteCumpleañosClientesAnular", this.remove);
      // EventBus.$on("ReporteCumpleañosClientesPrintList", this.imprimirList);
      // EventBus.$on("emitReporteCumpleañosClientes", this.datostabla);

      this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      windowSize: { width: "auto", height: "auto" },
      Rcliente: [],
      datos: {
        titulo: "Facturas a Vencer",
        UrlImprimir: "/reportescxc/imprimirDescuentosIndebidos",
        UrlExel: "/reportescxc/excelDescuentosIndebidos",
        UrlCorreo: "/reportescxc/correoDescuentosIndebidos",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        sucursal: null,
        vendedor: null,
      },

      sucursalList: [],
      vendedorList: [],
      searchVendedor: "",

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: true,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      FormatoFecha,
      fechaNueva,
      onResize(e) {
        this.windowSize = e
      },

      // Validando el formulario y luego configurando el valor de la propiedad cliente del objeto
      validarObjecto() {
        if (!this.$refs.form.validate()) {
          this.$refs.ModRepFilt.detener = true
          return
        } else {
          this.$refs.ModRepFilt.detener = false
        }
      },

      // Buscar todas las sucursales
      findAllSucursales() {
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.sucursalList = res.data
          })
          .catch((err) => {
            console.error(err)
          })
      },

      // Buscar vendedor por nombre
      findVendedor() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findAllByNombre", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchVendedor,
            },
          })
          .then((res) => {
            this.vendedorList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      save() {},
      remove() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},

      newwnuevo() {},

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      BlurDesde() {
        if (this.datos.desde.toString().length === 0) {
          this.datos.desde = this.fechaNueva()
        }
      },

      // Valida si el campo esta nulo, si lo esta coloca la fecha actual.
      BlurHasta() {
        if (this.datos.hasta.toString().length === 0) {
          this.datos.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e
          this.newwnuevo()
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e
          this.ejecucion = false
        }
      },
    },
    watch: {
      searchVendedor() {
        this.findVendedor()
      },
    },
  }
</script>

<style></style>
